import { Component } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import icClose from '@iconify/icons-ic/twotone-close';

@Component({
  selector: 'vex-inventory-document-required-dialog',
  template: `
    <div class="flex items-center justify-between mb-4">
      <h2 class="headline m-0">Document requis</h2>
      <button class="text-secondary" mat-icon-button (click)="dialogRef.close()" type="button">
        <mat-icon [icIcon]="icClose"></mat-icon>
      </button>
    </div>

    <div class="mb-6">
      <p class="body-1">
        Vous devez avoir déposé le document de type
        <strong>État des lieux de sortie</strong>
        pour ce bâtiment avant de pouvoir poursuivre cette action.
      </p>
    </div>

    <div class="flex justify-end">
      <button color="primary" mat-raised-button (click)="dialogRef.close()" type="button">OK</button>
    </div>
  `,
  styles: [],
})
export class InventoryDocumentRequiredDialogComponent {
  icClose = icClose;

  constructor(public dialogRef: MatDialogRef<InventoryDocumentRequiredDialogComponent>) {}
}
